import { FormattedMessageDiv, FormattedNumberDiv, Card } from "@odmonorepo/core-components"
import { Stack } from "react-bootstrap"

export const LOCSelectedDrawDetails = ({ offer, checkout }) => {
    return (
    <Card className="bg-light-gray shadow-none text-start" 
          bodyClassName="p-md-5 px-md-6 p-4">
          <Stack gap={3}>
                <FormattedMessageDiv
                  className="fw-bold"
                  id="offerPreview.selectedDrawDetails"
                />
                <Stack direction="horizontal">
                  <FormattedMessageDiv id="offerPreview.selectedDraw" />
                  <FormattedNumberDiv
                    value={parseInt(checkout.selectedDrawAmount)}
                    style="currency"
                    currency="USD"
                    className="ms-auto"
                  />
                </Stack>
                <Stack direction="horizontal">
                  <FormattedMessageDiv id="offerPreview.numberOfPayments" />
                  <div className="ms-auto">
                    {offer.pricedDetails.numberOfPayments}
                  </div>
                </Stack>
                <Stack direction="horizontal" className="align-items-end">
                  <FormattedMessageDiv id="offerPreview.estimatedPaymentAmount" />
                  <FormattedNumberDiv
                    value={checkout.estimatedPaymentAmount}
                    style="currency"
                    currency="USD"
                    className="ms-auto"
                  />
                </Stack>
            <Stack direction="horizontal" className="align-items-end">
              <FormattedMessageDiv id="offerPreview.paymentFrequency" />
              <div className="ms-auto">
                {offer.pricedDetails.paymentFrequency.toUpperCase() === 'WEEKLY'
                  ? 'Weekly'
                  : 'Monthly'}
              </div>
            </Stack>
          </Stack>
        </Card>
    );
                }